import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';

export default {
  destroy,
  store,
  show,
  update,
  all,
};



// WEBPACK FOOTER //
// ./src/app/services/marketplaceProduct/index.js